import React from 'react';
import styled from 'styled-components';
import { layout, colors } from 'Constants';

const Hero = styled.div`
background-image: url(${props => props.image});
background-size: cover;
width: 100%;
height: 450px;
display: flex;
align-items: center;
justify-content: center;
`;

const HeroInner = styled.div`
  max-width: ${layout.maxWidth};
  display: flex;
  width: 100%;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: auto;
  }
`;

export default class NavBar extends React.Component {
  render() {
    return (
      <Hero image={this.props.image}>
        <HeroInner>{this.props.children}</HeroInner>
      </Hero>
    );
  }
}
